import { View } from "react-native";

import { BlockRenderer } from "../blocks/BlockRenderer";

import { ModuleHero } from "./ModuleHero";
import { ScreenHeader } from "./ScreenHeader";

import type { Screen } from "@/lib/training/types";

type Content = Extract<Screen, { kind: "content" }>;

// Content card screen — header + a list of blocks
// (CPR_Course_Module1.html content cards, lines 358-428). A module-intro card
// `screen.hero` opens on the gradient banner instead of the plain header.

export function ContentScreen({ screen }: { screen: Content }) {
    return (
        <View>
            {screen.hero ? (
                <ModuleHero
                    mn={screen.hero.mn ?? ""}
                    title={screen.hero.title}
                    sub={screen.hero.sub ?? ""}
                />
            ) : (
                <ScreenHeader
                    kicker={screen.kicker ?? ""}
                    title={screen.title ?? ""}
                    lede={screen.lede ?? ""}
                />
            )}
            {(screen.blocks ?? []).map((b, i) => (
                <BlockRenderer key={i} block={b} />
            ))}
        </View>
    );
}
